import React from 'react'

const Cp_palin = () => {
    return (
        <div className='container'>
            <h1>Recursive program to check if number is palindrome or not</h1>
            <p>Given a number, the task is to write a recursive function which checks if the given number is palindrome or not. </p>
            <div className='output'>
            <p><strong>Examples: </strong></p>
            Input : 121 <br />
            Output : yes <br /></div>
            <p>The approach for writing the function is to call the function recursively till the number is completely traversed from the back. Use a temp variable to store the reverse of the number.Pass the temp variable in the parameter and once the base case of n==0 is achieved, return temp which stores the reverse of a number. 
Below is the implementation of the above approach: </p>
<div class="containers">
        <div class="line number1 index0 alt2"><code class="comment">// Recursive  program to check if the</code>
        </div>
        <div class="line number2 index1 alt1"><code class="comment">// number is palindrome or not</code></div>
        <div class="line number3 index2 alt2"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div>
        <div class="line number4 index3 alt1"><code class="library">using</code> <code
                        class="library">namespace</code> <code class="plain">std;</code></div>
        <div class="line number5 index4 alt2">&nbsp;</div>
        <div class="line number6 index5 alt1"><code
                        class="comment">// recursive function that returns the reverse of digits</code></div>
        <div class="line number7 index6 alt2"><code class="keywords">int</code> <code class="plain">rev(</code><code
                        class="keywords">int</code> <code class="plain">n, </code><code
                        class="keywords">int</code> <code class="plain">temp)</code></div>
        <div class="line number8 index7 alt1"><code class="plain">&#123;</code></div>
        <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// base case</code></div>
        <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">if</code> <code class="plain">(n == 0)</code></div>
        <div class="line number11 index10 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">return</code> <code class="plain">temp;</code></div>
        <div class="line number12 index11 alt1">&nbsp;</div>
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// stores the reverse of a number</code></div>
        <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">temp = (temp * 10) + (n % 10);</code></div>
        <div class="line number15 index14 alt2">&nbsp;</div>
        <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">return</code> <code class="plain">rev(n / 10, temp);</code></div>
        <div class="line number17 index16 alt2"><code class="plain">&#125;</code></div>
        <div class="line number18 index17 alt1">&nbsp;</div>
        <div class="line number20 index19 alt1"><code class="keywords">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number21 index20 alt2"><code class="plain">&#123;</code></div>
        <div class="line number22 index21 alt1">&nbsp;</div>
        <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">n = 121;</code></div>
        <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
        </div>
        <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">temp = rev(n, 0);</code></div>
        <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">if</code> <code class="plain">(temp == n)</code></div>
        <div class="line number28 index27 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"yes"</code> <code
                        class="plain">&lt;&lt; endl;</code></div>
        <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">else</code></div>
        <div class="line number30 index29 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"no"</code> <code
                        class="plain">&lt;&lt; endl;</code></div>
        <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">return</code> <code class="plain">0;</code></div>
        <div class="line number32 index31 alt1"><code class="plain">&#125;</code></div>
</div>
<div className='output'>
    <p><strong>Output: </strong></p>
    yes
</div>
        </div>
    )
}

export default Cp_palin
